import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaClock,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from "react-icons/fa";
import {
  getLiveSuburbs,
  getSuburbPath,
  LIVE_SUBURB_SLUG,
} from "../data/suburbs";

const SuburbComingSoonContent = ({ suburb }) => {
  const liveSuburb = getLiveSuburbs()[0];

  return (
    <main className='suburb-page suburb-page--soon'>
      <section className='suburb-soon-hero' aria-labelledby='suburb-soon-heading'>
        <div className='container'>
          <nav className='suburb-soon-breadcrumb' aria-label='Breadcrumb'>
            <Link to='/suburbs'>Suburbs</Link>
            <span aria-hidden='true'>/</span>
            <span>{suburb.name}</span>
          </nav>

          <div className='suburb-soon-hero__body'>
            <span className='suburb-soon-status'>
              <FaClock aria-hidden='true' />
              Coming Soon
            </span>
            <h1 id='suburb-soon-heading'>Car Rental {suburb.name}</h1>
            <p>
              We are preparing a dedicated car rental page for {suburb.name}. In
              the meantime, you can book today from our nearby Huntingdale depot
              — we already serve customers across Melbourne&apos;s south-east.
            </p>
          </div>
        </div>
      </section>

      <section className='suburb-soon-section' aria-labelledby='suburb-soon-cta-heading'>
        <div className='container suburb-soon-panel'>
          <div className='suburb-soon-panel__main'>
            <span className='suburb-soon-status suburb-soon-status--live'>
              Available Now
            </span>
            <h2 id='suburb-soon-cta-heading'>
              Need a car near {suburb.name} today?
            </h2>
            <p>
              While this page is being built, you can still rent with EZ Car
              Rentals from our Huntingdale location — just a short drive from{" "}
              {suburb.name} and surrounding suburbs.
            </p>

            <div className='suburb-soon-address'>
              <FaMapMarkerAlt aria-hidden='true' />
              <span>33B Clifford Street, Huntingdale VIC 3166</span>
            </div>

            <div className='suburb-soon-actions'>
              <Link to='/request-quote' className='suburb-soon-btn suburb-soon-btn--primary'>
                Request a Quote
                <FaArrowRight aria-hidden='true' />
              </Link>
              <a href='tel:0400920512' className='suburb-soon-btn suburb-soon-btn--ghost'>
                <FaPhoneAlt aria-hidden='true' />
                Call 0400 920 512
              </a>
            </div>
          </div>

          {liveSuburb && (
            <Link
              to={getSuburbPath(LIVE_SUBURB_SLUG)}
              className='suburb-soon-aside'
            >
              <span className='suburb-soon-aside__label'>
                Explore our live suburb page
              </span>
              <strong>Car Rental {liveSuburb.name}</strong>
              <span className='suburb-soon-aside__text'>
                View rates, fleet options and local hire information.
              </span>
              <span className='suburb-soon-aside__cta'>
                View page <FaArrowRight aria-hidden='true' />
              </span>
            </Link>
          )}
        </div>
      </section>
    </main>
  );
};

export default SuburbComingSoonContent;
